import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";

import MasonryReloadOnExpandController from "./MasonryReloadOnExpandController";

export default class MasonryReloadOnExpand implements IDirective {
    public bindToController = {
        masonryReloadOnExpand: "<",
    };

    public controller: Injectable<IControllerConstructor>;

    public controllerAs: "$ctrl";

    public restrict: "A";

    constructor() {
        this.controller = MasonryReloadOnExpandController;
    }
}

module("mmManagePortal").directive("masonryReloadOnExpand", () => new MasonryReloadOnExpand());
